import startSentryBrowser from '#common/modules/vendor/sentry';

startSentryBrowser({ scope: 'admin' });
